// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const StarSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 24 23"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.411.691A1 1 0 0111.362 0h1.276a1 1 0 01.95.691l2.05 6.304h6.63a1 1 0 01.953.694l.39 1.213a1 1 0 01-.364 1.116l-5.362 3.896 2.05 6.308a1 1 0 01-.363 1.117l-1.03.75a1 1 0 01-1.175 0L12 18.189l-5.37 3.902a1 1 0 01-1.176-.002l-1.027-.748a1 1 0 01-.362-1.117l2.05-6.31L.75 10.016a1 1 0 01-.363-1.117L.78 7.687a1 1 0 01.952-.692h6.632L10.411.691zM12.638 1h-1.276L9.314 7.304a1 1 0 01-.95.691H1.73l-.393 1.212 5.365 3.898a1 1 0 01.363 1.118l-2.05 6.31 1.027.749 5.37-3.901a1 1 0 011.175 0l5.367 3.899 1.03-.75-2.05-6.307a1 1 0 01.362-1.118l5.363-3.896-.39-1.214h-6.633a1 1 0 01-.95-.69L12.636 1h.002z"
      />
    </svg>
  )
}
